//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//原料主数据详情
const rawDataList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/rawData/list.vue');

//新增原料主数据
const rawDataAdd = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/rawData/add.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'rawDataList',
      name: 'rawDataList',
      component: rawDataList,
      meta: {
        keepAlive: true,
        title: '原料主数据',
      },
    },
    {
      path: 'rawDataAdd',
      name: 'rawDataAdd',
      component: rawDataAdd,
      meta: {
        keepAlive: true,
        title: '原料主数据新增',
      },
    },
  ],
};
export default productionRouter;
